import DetailLogCitc from './DetailLogCitc';

export default DetailLogCitc;
